import React from "react";

import { AttributeCardDisplayVariantType } from "../types";

import AttributeSelectionCard from "@/Components/PersonalAttributes/Components/AttributeSelectionCard";
import { type AppUserSession } from "@/schemas/auth/session";
import {
  UserWeightAttributeSet,
  Weight,
} from "@/schemas/profile/attributes/UserWeightAttributeSet";
import type { AttributeValue } from "@/schemas/attribute/AttributeSet";

type WeightProps = {
  session: AppUserSession;
  weightValue: Weight | null;
  variant: AttributeCardDisplayVariantType;
};

function WeightSelection({
  session,
  weightValue,
  variant,
}: WeightProps): React.JSX.Element {
  const values = weightValue ? [UserWeightAttributeSet.map[weightValue]] : [];
  const typedValues = values.filter(
    (item): item is AttributeValue => item !== undefined,
  );

  return (
    <AttributeSelectionCard
      session={session}
      attribute={UserWeightAttributeSet}
      values={typedValues}
      icon={"⚖"}
      variant={variant}
    />
  );
}

export default WeightSelection;
